import * as userAction from "../actions/profile.action";
const user = (
  state = {
    status: null,
    farprofileloading: false,
    profileloading: false,
    error: null,
    agentdetail: null,
    socialloading: false,
    profileData: null,
    feedbackData: null,
    recommendationData: null,
    loading: null,
    socialUpdateData: null,
    fetchCheckinsData: null,
    recommendationPostloading: null,
    shareProfileResponse: null,
    shareProfileloading: null,
    seoData: null,
    clickDetectorData: null,
    validateSpamResponse: null,
    reviewRatingResponseStatus: null,
  },
  action,
) => {
  switch (action.type) {
    case userAction.PROFILE_REQUEST:
      return Object.assign({}, state, {
        status: action.status,
        profileloading: true,
      });
    case userAction.PROFILE_SUCCESS:
      return Object.assign({}, state, {
        profileData: action.profileData,
        status: action.status,
        profileloading: false,
      });

    case userAction.PROFILE_FAILURE:
      return Object.assign({}, state, {
        error: action.error,
      });
    case userAction.SOCIAL_UPDATE_REQUEST:
      return Object.assign({}, state, {
        status: action.status,
        socialloading: true,
      });
    case userAction.SOCIAL_UPDATE_SUCCESS:
      return Object.assign({}, state, {
        socialUpdateData: action.socialUpdateData,
        status: action.status,
        socialloading: false,
      });

    case userAction.SOCIAL_UPDATE_FAILURE:
      return Object.assign({}, state, {
        error: action.error,
      });
    case userAction.CHECKINS_REQUEST:
      return Object.assign({}, state, {
        status: action.status,
        profileloading: true,
      });
    case userAction.CHECKINS_SUCCESS:
      return Object.assign({}, state, {
        fetchCheckinsData: action.fetchCheckinsData,
        status: action.status,
        profileloading: false,
      });

    case userAction.CHECKINS_FAILURE:
      return Object.assign({}, state, {
        error: action.error,
      });

    case userAction.FAR_PROFILE_REQUEST:
      return Object.assign({}, state, {
        status: action.status,
        farprofileloading: true,
      });
    case userAction.FAR_PROFILE_SUCCESS:
      return Object.assign({}, state, {
        agentdetail:
          action.selectedType && action.selectedType === "company"
            ? action.responseData.offices[0].office_bio
            : action.responseData.agents[0],
        seoData: { metadata: action?.responseData?.metadata },
        status: action.status,
        farprofileloading: false,
      });

    case userAction.FAR_PROFILE_FAILURE:
      return Object.assign({}, state, {
        error: action.error,
      });
    case userAction.FEEDBACK_REQUEST:
      return Object.assign({}, state, {
        status: action.status,
        loading: true,
      });
    case userAction.FEEDBACK_SUCCESS:
      return Object.assign({}, state, {
        feedbackData: action.feedbackData,
        status: action.status,
        loading: false,
      });
    case userAction.FEEDBACK_FAILURE:
      return Object.assign({}, state, {
        error: action.error,
      });
    case userAction.RECOMMENDATION_REQUEST:
      return Object.assign({}, state, {
        status: action.status,
        loading: true,
      });
    case userAction.RECOMMENDATION_SUCCESS:
      return Object.assign({}, state, {
        recommendationData: action.recommendationData,
        status: action.status,
        loading: false,
      });
    case userAction.RECOMMENDATION_FAILURE:
      return Object.assign({}, state, {
        error: action.error,
      });

    case userAction.HESTIA_REQUEST:
      return Object.assign({}, state, {
        status: action.status,
        loading: true,
      });
    case userAction.HESTIA_SUCCESS:
      return Object.assign({}, state, {
        hestiaData: action.hestiaData,
        status: action.status,
        loading: false,
      });
    case userAction.HESTIA_FAILURE:
      return Object.assign({}, state, {
        error: action.error,
      });
    case userAction.HESTIA_UPDATE_REQUEST:
      return Object.assign({}, state, {
        status: action.status,
        loading: true,
      });
    case userAction.HESTIA_UPDATE_SUCCESS:
      // eslint-disable-next-line no-case-declarations
      let hestiaData = { ...state.hestiaData };
      hestiaData.forSale.results = hestiaData.forSale.results.concat(
        action.hestiaUpdatedData.forSale.results,
      );
      hestiaData.forRent.results = hestiaData.forRent.results.concat(
        action.hestiaUpdatedData.forRent.results,
      );
      hestiaData.openHouses.results = hestiaData.openHouses.results.concat(
        action.hestiaUpdatedData.openHouses.results,
      );
      hestiaData.forSold.results = hestiaData.forSold.results.concat(
        action.hestiaUpdatedData.forSold.results,
      );
      return Object.assign({}, state, {
        hestiaData: hestiaData,
        status: action.status,
        loading: false,
      });
    case userAction.HESTIA_UPDATE_FAILURE:
      return Object.assign({}, state, {
        error: action.error,
      });
    case userAction.REVIEW_RATING_REQUEST:
      return Object.assign({}, state, {
        status: action.status,
        loading: true,
        reviewRatingResponseStatus: "Requesting",
      });
    case userAction.REVIEW_RATING_SUCCESS:
      return Object.assign({}, state, {
        reviewRatingResponse: action.reviewRatingResponse,
        status: action.status,
        loading: false,
        reviewRatingResponseStatus: "Success",
      });
    case userAction.REVIEW_RATING_FAILURE:
      return Object.assign({}, state, {
        error: action.error,
      });
    case userAction.NEW_RECOMMENDATION_REQUEST:
      return Object.assign({}, state, {
        status: action.status,
        recommendationPostloading: "Requesting",
      });
    case userAction.NEW_RECOMMENDATION_SUCCESS:
      return Object.assign({}, state, {
        newRecommendationResponse: action.newRecommendationResponse,
        status: action.status,
        recommendationPostloading: "Success",
      });
    case userAction.NEW_RECOMMENDATION_FAILURE:
      return Object.assign({}, state, {
        error: action.error,
      });
    case userAction.SHARE_PROFILE_REQUEST:
      return Object.assign({}, state, {
        status: action.status,
        shareProfileloading: "Requesting",
      });
    case userAction.SHARE_PROFILE_SUCCESS:
      return Object.assign({}, state, {
        shareProfileResponse: action.shareProfileResponse,
        status: action.status,
        shareProfileloading: "Success",
      });
    case userAction.SHARE_PROFILE_FAILURE:
      return Object.assign({}, state, {
        error: action.error,
      });
    case userAction.CLICK_DETECTOR_AND_SCROLL:
      return Object.assign({}, state, {
        clickDetectorData: action.clickDetectorData,
      });
    case userAction.VALIDATE_SPAM_REQUEST:
      return Object.assign({}, state, {
        status: action.status,
      });
    case userAction.VALIDATE_SPAM_SUCCESS:
      return Object.assign({}, state, {
        validateSpamResponse: action.validateSpamResponse,
        status: action.status,
      });
    case userAction.VALIDATE_SPAM_FAILURE:
      return Object.assign({}, state, {
        error: action.error,
      });
    default:
      return state;
  }
};
export default user;
